import "../../../../css/modal/TeacherManagementModal.css";
import LocationCode from "../../../../utils/constants/LocationCode";
import {
    checkValidDateElementWithPattern,
    getDateString,
    limitInputNumber,
    moveModal,
    setInvalidMessage
} from "../../../../utils/Utils";
import TeacherPasswordResetModal from "./TeacherPasswordResetModal";
import {useState} from "react";
import TeacherDetailsInfo from "../../../../utils/TeacherDetailsInfo";
import TeacherConstant from "../../../../utils/constants/TeacherConstant";
import Gender from "../../../../utils/constants/Gender";
import proxy from "../../../../utils/Proxy";

let TeacherDetailsModal = (props) => {
    let [editMode, setEditMode] = useState(false);
    let [resetPasswordIsOpen, setResetPasswordIsOpen] = useState(false)
    let [validBirth, setValidBirth] = useState(true)
    let [submitted, setSubmitted] = useState(false)

    let checkValidBirth = () => {
        let year = document.querySelector('input[name="teacher-details-birth-year"]')
        let month = document.querySelector('input[name="teacher-details-birth-month"]')
        let date = document.querySelector('input[name="teacher-details-birth-date"]')

        let valid = checkValidDateElementWithPattern(year, month, date);
        setValidBirth(valid)

        if (!valid) {
            document.getElementById("teacher-details-invalid-birth").innerHTML = TeacherDetailsInfo.invalidMessages.INVALID_DATE;
            return false;
        } else {
            document.getElementById("teacher-details-invalid-birth").innerHTML = "";
            return true;
        }
    }

    let setFired = () => {
        let teacherName = props.teacher.name;
        let dialogResult = window.confirm(teacherName + " 강사(매니저)를 퇴사 처리하시겠습니까?");
        if (dialogResult) {
            proxy.delete("/adminapi/teachers/" + props.teacher.teacherid).then(() => {
                window.alert("퇴사 처리가 완료되었습니다.");
                props.setClosed();
                props.setNeedUpdate(true)
            }).catch(err => {
                window.alert(err.response.data.message)
            })
        }
    }

    let onBirthChange = (e, len) => {
        limitInputNumber(e, len);
        checkValidBirth();
    }

    let save = () => {
        let dialogResult = window.confirm("저장 하시겠습니까?");
        if (!dialogResult) return;

        setSubmitted(true);
        // valid check
        let invalidList = []
        let editableTextIndex = 0;
        for (let i = 0; i < TeacherDetailsInfo.detailLabel.length; i++) {
            let name = TeacherDetailsInfo.detailDataName[i];
            if (TeacherDetailsInfo.editableInputs.indexOf(name) === -1) continue;
            if (name === "location" || name === "major" || name === "gender") continue;

            if (name === "birth") {
                if (!checkValidBirth()) invalidList.push(TeacherDetailsInfo.detailLabel[i]);
                continue;
            }
            let validityTarget = document.querySelector('input[name="teacher-details-' + name + '"]')
            let valid = validityTarget.validity.valid;
            if (!valid) invalidList.push(TeacherDetailsInfo.detailLabel[i]);
            let invalid = TeacherDetailsInfo.editableTextInvalid[editableTextIndex];
            setInvalidMessage(validityTarget, "teacher-details-invalid-" + name, TeacherDetailsInfo.invalidMessages[invalid])
            editableTextIndex++;
        }
        if (invalidList.length > 0) {
            let message = "";
            for (let invalid of invalidList)
                message += invalid + ", ";
            message = message.slice(0, -2)

            window.alert("잘못된 형식입니다.\n(" + message + ")");

            return;
        }
        // 현재 input box 값 읽어서 props로 받은 값과 대조 후 다른것만 put 보내기
        // read edit data
        let edit = {};

        for (let i = 0; i < TeacherDetailsInfo.detailLabel.length; i++) {
            let name = TeacherDetailsInfo.detailDataName[i];
            if (TeacherDetailsInfo.editableInputs.indexOf(name) === -1) continue;
            let keyword = "teacher-details-" + name;
            switch (name) {
                case "location":
                case "gender":
                case "major":
                    let radioList = document.getElementsByName(keyword);
                    for (let j = 0; j < radioList.length; j++) {
                        if (radioList[j].checked) {
                            edit[name] = j;
                            break;
                        }
                    }
                    break;
                case "birth":
                    let year = document.querySelector('input[name="' + keyword + '-year"]').value
                    let month = document.querySelector('input[name="' + keyword + '-month"]').value
                    let date = document.querySelector('input[name="' + keyword + '-date"]').value

                    let birth = new Date(year, month - 1, date);
                    edit[name] = getDateString(birth);
                    break;
                case "working_days":
                    edit[name] = parseInt(document.querySelector('input[name="' + keyword + '"]').value);
                    break;
                default:
                    edit[name] = document.querySelector('input[name="' + keyword + '"]').value;
            }
        }
        let body = {};
        for (let name of TeacherDetailsInfo.detailDataName) {
            if (name === "birth") continue;
            if (edit[name] !== undefined && props.teacher[name] !== edit[name]) {
                body[name] = edit[name];
            }
        }
        if (edit["birth"] !== getDateString(new Date(props.teacher["birth"]))) {
            body["birth"] = edit["birth"]
        }
        proxy.put("/adminapi/teachers/" + props.teacher.teacherid, body).then(() => {
            window.alert("정보가 수정되었습니다.");
            setEditMode(false)
            setValidBirth(true)
            setSubmitted(false)
            props.setNeedUpdate(true)
        }).catch(res => window.alert(res.response.data.message));
    };

    let cancelEditTeacherInfo = () => {
        let dialogResult = window.confirm("취소 하시겠습니까?")
        if (dialogResult) {
            setEditMode(false)
            setValidBirth(true)
            setSubmitted(false)
        }
    }

    let getRadios = (dataName, inputName, inputData) => {
        let ret = [];
        for (let dataId in inputData) {
            let key = inputName + ":" + dataId;
            let checked = props.teacher[dataName] === parseInt(dataId);
            ret.push(
                <label className="modal-input-radio-label" key={key}>
                    <input type="radio"
                           name={inputName}
                           value={parseInt(dataId)}
                           defaultChecked={checked}/>
                    <p>{inputData[dataId]}</p>
                </label>
            )
        }
        return <div className="modal-input-radio-container">{ret}</div>;
    }

    let getEditInput = () => {
        let info = TeacherDetailsInfo;
        let res = [];
        let editTextIndex = 0;
        for (let detailIndex in info.detailDataName) {
            let label = info.detailLabel[detailIndex];
            let dataName = info.detailDataName[detailIndex];
            let inputName = info.getInputName(dataName);
            let invalidMessageId = info.getInvalidMessageId(dataName);
            let data = props.teacher[dataName];
            let dataText = info.getDataText(dataName, data)

            let key = "teacher-details-" + dataName
            if (info.editableInputs.indexOf(dataName) !== -1 && editMode) {

                let input;
                if (info.editableTextInputs.indexOf(dataName) !== -1) {
                    let invalidMessage = info.invalidMessages[info.editableTextInvalid[editTextIndex]]
                    let limit = info.editableTextLimits[editTextIndex]
                    input = (
                        <input
                            className={"modal-input" + (submitted ? " modal-input-submitted" : "")}
                            defaultValue={data} name={inputName}
                            onChange={(e) => {
                                setInvalidMessage(e.target, invalidMessageId, invalidMessage)
                                limitInputNumber(e, limit)
                            }}
                            pattern={info.editableTextRegex[editTextIndex]} required/>
                    )
                    editTextIndex++;
                } else if (info.editableRadioInputs.indexOf(dataName) !== -1) {
                    switch (dataName) {
                        case "location":
                            input = getRadios(dataName, inputName, LocationCode.text);
                            break;
                        case "major":
                            input = getRadios(dataName, inputName, TeacherConstant.major_text);
                            break;
                        case "gender":
                            input = getRadios(dataName, inputName, Gender.text)
                            break;
                        default:
                            input = null;
                    }
                } else if (dataName === "birth") {
                    let birthDate = new Date(data);
                    let year = birthDate.getFullYear();
                    let month = birthDate.getMonth() + 1;
                    let date = birthDate.getDate();
                    input = (
                        <div className={!submitted || validBirth ?
                            "modal-input" : "modal-input-invalid"}>
                            <input className="modal-input-date" name={inputName + "-year"}
                                   defaultValue={year} onChange={e => onBirthChange(e, 4)}
                                   pattern="\d{4}" required></input>
                            <p>-</p>
                            <input className="modal-input-date" name={inputName + "-month"}
                                   defaultValue={month} onChange={e => onBirthChange(e, 2)}
                                   pattern="0?[1-9]|1[0-2]" required></input>
                            <p>-</p>
                            <input className="modal-input-date" name={inputName + "-date"}
                                   defaultValue={date} onChange={e => onBirthChange(e, 2)}
                                   pattern="0?[1-9]|[1-2][0-9]|3[0-1]" required></input>
                        </div>
                    )
                }
                res.push(
                    <div className="modal-content-item modal-content-align-start" key={key}>
                        <div className="modal-content-divider-2">
                            <p className="modal-content-text">{label}</p>
                        </div>
                        <div className="modal-content-divider-2">
                            {input}
                            <p className="modal-input-invalid-message" id={invalidMessageId}/>
                        </div>
                    </div>
                )
            } else {
                res.push(
                    <div className="modal-content-item modal-content-align-start" key={key}>
                        <div className="modal-content-divider-2">
                            <p className="modal-content-text">{label}</p>
                        </div>
                        <div className="modal-content-divider-2">
                            <p className="modal-content-text">{dataText}</p>
                        </div>
                    </div>
                )
            }
        }
        return res;
    }

    return (
        <div className="modal-container">
            <div className="modal" id="teacher-details-modal">
                <div className="modal-content-container">
                    <div className="modal-header" onMouseDown={e => moveModal(e, "teacher-details-modal")}>
                        <p className="modal-title">
                            {props.teacher.name}님의 정보
                        </p>
                        <div className="modal-close-button" onClick={() => props.setClosed()}>
                        </div>
                    </div>
                    <div className="modal-content teacher-details-content">
                        {getEditInput()}
                    </div>
                    <div className="modal-footer">
                        <div className="modal-footer-button-container">
                            {editMode ?
                                (<>
                                    <div className="modal-button" onClick={save}>
                                        <p>저장</p>
                                    </div>
                                    <div className="modal-button" onClick={cancelEditTeacherInfo}>
                                        <p>취소</p>
                                    </div>
                                </>) :
                                (<>
                                    <div className="modal-button" onClick={() => setEditMode(true)}>
                                        <p>수정</p>
                                    </div>
                                    <div className="modal-button" onClick={() => setFired()}>
                                        <p>퇴사 처리하기</p>
                                    </div>
                                    <div className="modal-button" onClick={() => setResetPasswordIsOpen(true)}>
                                        <p>비밀번호 변경</p>
                                    </div>
                                </>)}

                            {resetPasswordIsOpen ?
                                <TeacherPasswordResetModal
                                    teacherid={props.teacher.teacherid}
                                    onCloseClick={() => setResetPasswordIsOpen(false)}/> : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>)
}
export default TeacherDetailsModal;